import React from 'react'
import { connect } from 'react-redux';
import Wix from 'Wix';
import { CaptionContainer, TextCaptionContainer, CountdownContainer, CountdownList, CountdownItem, CountdownHidedList, CountdownHidedItem } from '../style'
import { getDiffToMobileConvert, convertMobileUmitableFields } from '../../../../../editSlide/api/converter';
import { getCaptionContainerStyle, getCaptionTextStyle, getCaptionContainerStyleMobile, getCaptionTextStyleMobile } from '../../../../../Utils/prevVersionAdaptive';
import { flipLeftToRightWords, getBackgroundGradient, getValueAccordingToLanguage } from '../../../../../Utils/utils';
import { CountdownCubeItem, CountdownCubeList, CreditsContainer, CreditsHiddenList, CreditsItem, CreditsItemContent } from '../../../../../editSlide/modules/MainView/Workspace/Captions/style';
import { getRightPropertyValue } from '../../../../../Utils/helpers';


class TextCaption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            containerStyle: {},
            captionStyle: {},
            captionText: this.props.caption.text
        }
    }


    componentWillMount() {
        const lang = this.props.lang
        const locale = this.props.locale
        const deviceType = this.props.slideJustTranspiled ? 'desktop' : Wix.Utils.getDeviceType()
        let caption = null;
        const isMobile = deviceType === 'mobile'
        // console.log('this.props.slide', this.props.slide)
        // const desktopDims = { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight }
        const desktopDims = this.props.slide === undefined ? { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight } : { width: this.props.slide.editedWidth, height: this.props.slide.editedHeight }
        // const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        // const mobileDims = { width: this.props.slide.editedWidthMobile, height: this.props.slide.editedHeightMobile }
        const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        if (deviceType === 'mobile') {
            const { mobileDiffW, mobileDiffH } = getDiffToMobileConvert(
                this.props.widgetDimensions.width,
                this.props.widgetDimensions.height,
                this.props.widgetDimensions.mobileWidth,
                this.props.widgetDimensions.mobileHeight,
            )
            const maxDiff = mobileDiffW > mobileDiffH ? mobileDiffW : mobileDiffH
            caption = convertMobileUmitableFields(_.cloneDeep(this.props.caption), mobileDiffW, mobileDiffH, maxDiff)
        } else {
            caption = this.props.caption
        }

        let borderRadiusProperty, borderWidthProperty, fontSizeProperty, lineHeightProperty,
            paddingProperty, widthProperty, positionProperty, heightProperty, letterSpacingProperty;

        switch (deviceType) {
            case 'desktop':
                borderRadiusProperty = 'borderRadius';
                borderWidthProperty = 'borderWidth';
                fontSizeProperty = 'fontSize';
                lineHeightProperty = 'lineHeight';
                paddingProperty = 'padding';
                widthProperty = 'width';
                heightProperty = 'height';
                positionProperty = 'position';
                letterSpacingProperty = 'letterSpacing';
                break;

            case 'mobile':
                borderRadiusProperty = 'mobileBorderRadius';
                borderWidthProperty = 'mobileBorderWidth';
                fontSizeProperty = 'mobileFontSize';
                lineHeightProperty = 'mobileLineHeight';
                paddingProperty = 'mobilePadding';
                widthProperty = 'mobileWidth';
                heightProperty = 'mobileHeight';
                positionProperty = 'mobilePosition';
                letterSpacingProperty = 'mobileLetterSpacing';
                break;
        }
        const diffBetwenFontSizeAndLineHeight = (caption[fontSizeProperty]) - (caption[lineHeightProperty] / 100 * caption[fontSizeProperty]);
        // const diffBetwenFontSizeAndLineHeight = (1.2 * caption[fontSizeProperty]) - (caption[lineHeightProperty] / 100 * caption[fontSizeProperty]);
        const needMobileConvert = caption.needMobileConvert || false

        // console.log('text caption dims', desktopDims, mobileDims)
        // console.log('text caption', caption)
        // console.log('=====================')
        let captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, caption, 1, '', true, needMobileConvert)
        if (caption.boxId !== '' && isMobile && caption.mobilePosition && caption.mobilePosition.relativeX == undefined) {
            const clonedCaption = _.cloneDeep(caption)
            delete clonedCaption.mobilePosition
            const convertedPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, clonedCaption, 1, '', true, needMobileConvert)
            captionPosition = {
                ...captionPosition,
                relativeX: convertedPosition.relativeX,
                relativeY: convertedPosition.relativeY
            }
        }
        const xProp = caption.boxId === '' ? 'x' : 'relativeX'
        const yProp = caption.boxId === '' ? 'y' : 'relativeY'
        let containerStyle = {
            top: captionPosition[yProp],
            left: captionPosition[xProp],
            opacity: caption.animationIn != 'none' ? 0 : 1,
        }
        // const captionText = getValueAccordingToLanguage(caption, 'text', lang, locale)
        const captionText = caption.text;

        //doesn't work properly
        // const fontFamily = getValueAccordingToLanguage(caption, 'fontFamily', lang, locale)
        const fontFamily = caption.fontFamily;
        // const rtl = getValueAccordingToLanguage(caption, 'isRTL', lang, locale)
        const rtl = caption.isRTL
        // const isRTL = caption.fontFamily ? (caption.fontFamily.custom ? caption.isRTL : caption.fontFamily.rtl) : false
        const isRTL = rtl === undefined ? (fontFamily ? fontFamily.rtl : false) : rtl
        // const isRTL = caption.isRTL === undefined ? (caption.fontFamily ? caption.fontFamily.rtl : false) : caption.isRTL

        // console.log("Font from lang", fontFamily);
        // let captionStyle = {
        //     backgroundColor: caption.backgroundColor,
        //     borderColor: caption.borderColor,
        //     borderRadius: caption[borderRadiusProperty],
        //     borderWidth: caption[borderWidthProperty],
        //     color: caption.fontColor,
        //     fontFamily: (fontFamily && fontFamily.value != undefined) ? fontFamily.value : 'Helvetica',
        //     // fontFamily: (caption.fontFamily && caption.fontFamily.value != undefined) ? caption.fontFamily.value : 'Helvetica',
        //     shadow: !caption.hasShadow ? '' : `${caption.shadow.x}px ${caption.shadow.y}px ${caption.shadow.blur}px ${caption.shadow.color}`,

        //     fontSize: caption[fontSizeProperty],
        //     lineHeight: caption[lineHeightProperty],
        //     fontStyle: (caption.style && caption.style.italic) ? 'italic' : '',
        //     fontWeight: (fontFamily && fontFamily.fontWeight) || ((caption.style && caption.style.bold) ? 'bold' : ''),
        //     // fontWeight: (caption.fontFamily && caption.fontFamily.fontWeight) || ((caption.style && caption.style.bold) ? 'bold' : ''),
        //     underline: (caption.style && caption.style.underline) ? 'underline' : caption.style.strikethrough ? 'line-through' : 'none',
        //     padding: caption[paddingProperty],
        //     // textShadow: caption.fontShadow ?
        //     //     '2px 1px 4px rgba(0, 0, 0, 0.7)' : null,
        //     textAlign: caption.style && caption.style.textAlign,
        //     letterSpacing: caption[letterSpacingProperty],
        //     textTransform: caption.letterCase || 'none',
        //     isHover: caption.isHover,
        //     fontColorHover: caption.fontColorHover,
        //     borderColorHover: caption.borderColorHover,
        //     backgroundColorHover: caption.backgroundColorHover,
        //     width: caption[widthProperty],
        //     zIndex: caption.layer + 200,
        //     diffBetwenFontSizeAndLineHeight: diffBetwenFontSizeAndLineHeight > 0 ? Math.round(diffBetwenFontSizeAndLineHeight / 2) : 0,
        //     direction: isRTL ? 'rtl' : '',
        //     textStroke: `${caption.textStroke ? caption.textStroke.size : 0}px ${caption.textStroke ? caption.textStroke.color : 'rgba(255, 0, 0, .5)'}`,

        //     // direction: (caption.fontFamily && caption.fontFamily.rtl) ? 'rtl' : '',
        // }
        let captionStyle = {
            backgroundColor: caption.backgroundColor,
            borderColor: caption.borderColor,
            padding: getRightPropertyValue(desktopDims, mobileDims, 'padding', isMobile, caption, 1, '', true, needMobileConvert),

            borderRadius: getRightPropertyValue(desktopDims, mobileDims, 'borderRadius', isMobile, caption, 1, '', true, needMobileConvert),
            borderWidth: getRightPropertyValue(desktopDims, mobileDims, 'borderWidth', isMobile, caption, 1, '', true, needMobileConvert),
            color: caption.fontColor,
            fontFamily: (fontFamily && fontFamily.value != undefined) ? fontFamily.value : 'Helvetica',
            // fontFamily: (caption.fontFamily && caption.fontFamily.value != undefined) ? caption.fontFamily.value : 'Helvetica',
            shadow: !caption.hasShadow ? '' : `${caption.shadow.x}px ${caption.shadow.y}px ${caption.shadow.blur}px ${caption.shadow.color}`,

            fontSize: getRightPropertyValue(desktopDims, mobileDims, 'fontSize', isMobile, caption, 1, '', true, needMobileConvert),
            lineHeight: getRightPropertyValue(desktopDims, mobileDims, 'lineHeight', isMobile, caption, 1, '', true, needMobileConvert),
            fontStyle: (caption.style && caption.style.italic) ? 'italic' : '',
            fontWeight: (fontFamily && fontFamily.fontWeight) || ((caption.style && caption.style.bold) ? 'bold' : ''),
            // fontWeight: (caption.fontFamily && caption.fontFamily.fontWeight) || ((caption.style && caption.style.bold) ? 'bold' : ''),
            underline: (caption.style && caption.style.underline) ? 'underline' : caption.style.strikethrough ? 'line-through' : 'none',
            // textShadow: caption.fontShadow ?
            //     '2px 1px 4px rgba(0, 0, 0, 0.7)' : null,
            textAlign: caption.style && caption.style.textAlign,
            letterSpacing: getRightPropertyValue(desktopDims, mobileDims, 'letterSpacing', isMobile, caption, 1, '', true, needMobileConvert),
            textTransform: caption.letterCase || 'none',
            isHover: caption.isHover,
            fontColorHover: caption.fontColorHover,
            colorHover: caption.colorHover,
            borderColorHover: caption.borderColorHover,
            backgroundColorHover: caption.backgroundColorHover,
            width: getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, caption, 1, '', true, needMobileConvert),
            zIndex: caption.layer + 200,
            diffBetwenFontSizeAndLineHeight: diffBetwenFontSizeAndLineHeight > 0 ? Math.round(diffBetwenFontSizeAndLineHeight / 2) : 0,
            direction: isRTL ? 'rtl' : '',
            textStroke: `${caption.textStroke ? getRightPropertyValue(desktopDims, mobileDims, 'size', isMobile, caption.textStroke, 1, '', false, needMobileConvert) : 0}px ${caption.textStroke ? caption.textStroke.color : 'rgba(255, 0, 0, .5)'}`,

            // direction: (caption.fontFamily && caption.fontFamily.rtl) ? 'rtl' : '',
        }
        // на случай обратной совместимости, т.к. не все свойства раньше конвертировались
        if (this.props.slideJustTranspiled) {
            captionStyle.borderRadius = caption.borderRadius
            captionStyle.shadow = caption.hasShadow ? '2px 1px 4px rgb(0, 0, 0, 0.7)' : ''
            captionStyle.diffBetwenFontSizeAndLineHeight = 0
        }

        // if (this.props.slideJustTranspiled) {
        //     containerStyle = getCaptionContainerStyle(caption, this.props.widgetDimensions.width, this.props.widgetDimensions.height)
        // }
        // console.log('containerStyle',containerStyle)

        this.setState({ containerStyle, captionStyle, captionText })
    }

    goToLink() {
        if (this.props.caption.onClick && this.props.caption.onClick.value === 'doNothing') return
        // сначала проверяем, есть ли ссылка из новых настроек
        if (this.props.caption.linkTo) {
            if (this.props.caption.linkTo.type === "AnchorLink" && this.props.caption.linkTo.anchorDataId == '') {
                // при конвертации со старых настроек не получить id якоря, поэтому оставил поле с ним пустым и использую старую функцию
                Wix.navigateToAnchor(this.props.caption.linkTo.anchorName, function (error) { console.log(error.error) });
            } else {
                // для всех новых настроек подойдёт эта функция
                Wix.navigateTo(this.props.caption.linkTo, () => { })
            }
        }
    }

    getClassname() {
        // if (this.props.menuReducer.currentSlide === this.props.slideIndex) {
        //     return `caption-${this.props.slideIndex}-${this.props.captionIndex}`
        // } else {
        const unicalClassName = this.props.unicalClassName ? `caption-${this.props.slideIndex}-${this.props.captionIndex}-${this.props.unicalClassName} ` : ''
        return `caption-${this.props.slideIndex}-${this.props.captionIndex} text-caption ${unicalClassName}  ${this.props.caption.animationIn == 'stripes' ? 'stripes-animation' : ''}`
        // }
    }

    renderCountdownText(caption, stylesTextP, captionStyle, className) {
        const itemStyle = {
            direction: stylesTextP.direction,
            padding: stylesTextP.padding,
            textDecoration: stylesTextP.textDecoration,
            justifyContent: stylesTextP.textAlign === 'left' ? 'flex-start' : stylesTextP.textAlign === 'right' ? 'flex-end' : 'center'
        }
        // направление текста влияет на flex выравнивание
        if (stylesTextP.direction === 'rtl') {
            itemStyle.justifyContent = stylesTextP.textAlign === 'left' ? 'flex-end' : stylesTextP.textAlign === 'right' ? 'flex-start' : 'center'
        }

        let dataDirection = ''

        switch (caption.animationIn) {
            case 'countdownUp':
                dataDirection = 'up'
                break
            case 'countdownDown':
                dataDirection = 'down'
                break
            case 'countdownCube':
                dataDirection = 'cube'
                break
            case 'countdownCubeRev':
                dataDirection = 'cube-rev'
                break
        }

        const fontSize = parseInt(stylesTextP.fontSize)
        const padding = parseInt(stylesTextP.padding)
        const deviceType = this.props.slideJustTranspiled ? 'desktop' : Wix.Utils.getDeviceType()
        const isMobile = deviceType === 'mobile'
        const desktopDims = { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight }
        const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        const cubeSize = getRightPropertyValue(desktopDims, mobileDims, 'cubeHeight', isMobile, caption)

        if (caption.animationIn.includes('countdownCube')) {
            return (
                <CountdownContainer
                    id={`text-caption-${caption.id}`}
                    key={`TextP1-${this.props.previewSlide}`}
                    className={`countdown-container cube ${className}`}
                    style={{ ...stylesTextP, direction: '', overflow: 'visible' }}
                    captionStyle={captionStyle}
                    data-pauseBetweenLines={caption.pauseBetweenLines || 0}
                    data-delayIn={caption.delayIn || 0}
                    data-delayOut={caption.delayOut || 0}
                    data-loop={caption.isLoopAnimation}
                    data-direction={dataDirection}
                >
                    <CountdownCubeList
                        style={{ flexDirection: caption.animationIn === 'countdownDown' ? 'column-reverse' : 'column' }}
                        className={'countdown-list'}
                        fontSize={fontSize}
                        padding={padding}
                        size={cubeSize}
                    >
                        {caption.text.map((line, index) => {
                            return (
                                <CountdownCubeItem
                                    color={caption.lineColors ? caption.lineColors[index] : caption.fontColor}
                                    className={'contdown-item'}
                                    key={'countdown' + index}
                                    style={{ ...itemStyle, visibility: index == 0 ? 'visible' : '' }}
                                    index={index}
                                    fontSize={fontSize}
                                    size={cubeSize}
                                    padding={padding}
                                    amount={caption.text.length}
                                    data-translate={fontSize}
                                    directionSign={dataDirection === 'cube' ? 1 : -1}
                                >
                                    {`${line}`}
                                </CountdownCubeItem>
                            )
                        })}
                    </CountdownCubeList>
                    <CountdownHidedList>
                        {caption.text.map((line, index) => {
                            return (
                                <CountdownHidedItem
                                    key={'countdown' + index}
                                >
                                    {`${line}`}
                                </CountdownHidedItem>
                            )
                        })}
                    </CountdownHidedList>
                </CountdownContainer>
            )
        }

        return (
            <CountdownContainer
                id={`text-caption-${caption.id}`}
                // key={`TextP-${this.props.previewSlide}`}
                className={`countdown-container ${className}`}
                style={stylesTextP}
                captionStyle={captionStyle}
                data-pauseBetweenLines={caption.pauseBetweenLines || 0}
                data-delayIn={caption.delayIn || 0}
                data-delayOut={caption.delayOut || 0}
                data-loop={caption.isLoopAnimation}
                data-direction={caption.animationIn === 'countdownDown' ? 'down' : 'up'}
                data-id={`${caption.id}`}
            >
                <CountdownList
                    style={{ flexDirection: caption.animationIn === 'countdownDown' ? 'column-reverse' : 'column' }}
                    className={'countdown-list'}
                >
                    {caption.text.map((line, index) => {
                        return (
                            <CountdownItem
                                color={caption.lineColors ? caption.lineColors[index] : caption.fontColor}
                                className={'contdown-item'}
                                key={'countdown' + index}
                                // padding={stylesTextP.padding}
                                // justifyContent={stylesTextP.textAlign === 'left' ? 'flex-start': stylesTextP.textAlign === 'right' ? 'flex-end' : 'center'}
                                // colorHover={captionStyle.colorHover}
                                style={itemStyle}
                            >
                                {`${line}`}
                            </CountdownItem>
                        )
                    })}
                </CountdownList>
                <CountdownHidedList>
                    {caption.text.map((line, index) => {
                        return (
                            <CountdownHidedItem
                                key={'countdown' + index}
                            >
                                {`${line}`}
                            </CountdownHidedItem>
                        )
                    })}
                </CountdownHidedList>
            </CountdownContainer>
        )
    }

    renderCreditsText(caption, stylesTextP, captionStyle, unicClassName) {
        const itemStyle = {
            direction: stylesTextP.direction,
            padding: stylesTextP.padding,
            textDecoration: stylesTextP.textDecoration,
        }

        // направление текста влияет на flex выравнивание


        return (
            <CreditsContainer
                id={`text-caption-${caption.id}`}
                key={`TextP1-${this.props.previewSlide}`}
                className={`credits-container elem-text caption-${this.props.slideIndex}-${caption.index} ${unicClassName}`}
                style={{ ...stylesTextP, direction: '' }}
                captionStyle={captionStyle}
                data-pauseBetweenLines={caption.pauseBetweenLines || 0}
                data-delayIn={caption.delayIn || 0}
                data-delayOut={caption.delayOut || 0}
                data-loop={caption.isLoopAnimation}
                data-direction={caption.animationIn === 'credits-forward' ? 'forward' : 'backward'}
            >
                <CreditsHiddenList>
                    {caption.text.map((line, index) => {
                        return (
                            <CreditsItem
                                color={caption.lineColors ? caption.lineColors[index] : caption.fontColor}
                                className={'credits-item'}
                                key={'credit' + index}
                                style={{ ...itemStyle, position: 'relative', transform: 'translate(0)', padding: '0', height: 'fit-content' }}
                            >
                                <CreditsItemContent>
                                    {`${line}`}
                                </CreditsItemContent>
                            </CreditsItem>
                        )
                    })}
                </CreditsHiddenList>

                {caption.text.map((line, index) => {
                    return (
                        <CreditsItem
                            color={caption.lineColors ? caption.lineColors[index] : caption.fontColor}
                            className={'credits-item-visible'}
                            key={'credit' + index}
                            style={{ ...itemStyle }}
                        >
                            <CreditsItemContent
                                direction={caption.animationIn === 'credits-forward' ? 'forward' : 'backward'}
                                className={`credits-content`}
                                style={{}}
                            >
                                {`${line}`}
                            </CreditsItemContent>
                        </CreditsItem>
                    )
                })}
            </CreditsContainer>
        )
    }

    render() {
        const caption = _.cloneDeep(this.props.caption)
        const captionStyle = _.cloneDeep(this.state.captionStyle)
        caption.text = this.state.captionText

        let isLink = false
        //  если на тексте висит ссылка, то cursor: pointer
        if (this.props.caption.onClick && this.props.caption.onClick.value === 'goToLink') {
            isLink = true
        }

        let TextCaptionStyles = {
            width: `${this.state.captionStyle.width}px`,
            top: `${this.state.containerStyle.top}px`,
            left: `${this.state.containerStyle.left}px`,
            zIndex: this.state.captionStyle.zIndex,
        }
        let ParagraphStyles = {
            backgroundColor: this.state.captionStyle.backgroundColor,
            borderStyle: 'solid',
            borderColor: this.state.captionStyle.borderColor,
            borderRadius: `${this.state.captionStyle.borderRadius}px`,
            borderWidth: `${this.state.captionStyle.borderWidth}px`,
            color: this.state.captionStyle.color,
            fontFamily: this.state.captionStyle.fontFamily,
            fontSize: `${Math.floor(this.state.captionStyle.fontSize)}px`,
            fontStyle: this.state.captionStyle.fontStyle,
            fontWeight: `${this.state.captionStyle.fontWeight}`,
            lineHeight: `${this.state.captionStyle.lineHeight / 100 * this.state.captionStyle.fontSize}px`,
            margin: 0,
            padding: `${Math.floor(this.state.captionStyle.padding + this.state.captionStyle.diffBetwenFontSizeAndLineHeight)}px ${Math.floor(this.state.captionStyle.padding)}px`,
            textShadow: this.state.captionStyle.shadow,
            textAlign: this.state.captionStyle.textAlign,
            textTransform: captionStyle.textTransform,
            letterSpacing: `${this.state.captionStyle.letterSpacing / 100}em`,
            transition: '0.25s',
            wordWrap: 'anywhere',
            whiteSpace: 'pre-wrap',
            opacity: 1,
            // opacity: 0,
            cursor: isLink ? 'pointer' : '',
            direction: `${this.state.captionStyle.direction}`,
            textDecoration: `${(caption.animationIn === 'typing' || caption.animationIn === 'stripes' || caption.animationIn.includes('credits')  || caption.animationIn.includes('countdown') || (caption.animationIn === 'none' && caption.animationOut === 'none')) ? this.state.captionStyle.underline : ''}`,
            WebkitTextStroke: this.state.captionStyle.textStroke,
        }

        if (this.props.slideJustTranspiled) {
            if (Wix.Utils.getDeviceType() === 'mobile') {
                TextCaptionStyles = getCaptionContainerStyleMobile(caption, this.props.widgetDimensions)
                ParagraphStyles = getCaptionTextStyleMobile(this.state.captionStyle, this.props.widgetDimensions)
                TextCaptionStyles.zIndex = this.state.captionStyle.zIndex
            } else {
                TextCaptionStyles = getCaptionContainerStyle(caption, this.props.widgetDimensions.width, this.props.widgetDimensions.height)
                TextCaptionStyles.zIndex = this.state.captionStyle.zIndex
                ParagraphStyles = getCaptionTextStyle(this.state.captionStyle, isLink)
            }
        }




        if (captionStyle.textTransform === 'capitalize') {
            // если первая буква - заглавная, то text-transform отменяем, и мутируем саму строку
            // т.к. анимация делит слово на буквы и получается, что каждая буква - заглавная
            const re = /(?:^|\s|[-"()[\]{}.?;!@#$%^&*+=|<>`~,\\/])+\S/g;
            ParagraphStyles.textTransform = 'none'
            // if (caption.animationIn === 'typing' || caption.animationIn === 'countdownUp' || caption.animationIn === 'countdownDown') {
            if (Array.isArray(caption.text)) {
                caption.text = caption.text.map(line => line.toLowerCase().replace(re, c => c.toUpperCase()))
            } else {
                caption.text = caption.text.toLowerCase().replace(re, c => c.toUpperCase())
            }
        }

        if (this.state.captionStyle.direction === 'rtl' && !(caption.animationIn === 'none' && caption.animationOut === 'none')
            && caption.animationIn !== 'countdownUp' && caption.animationIn !== 'countdownDown' && caption.animationIn !== 'stripes' && caption.boxId == '') {
            caption.text = flipLeftToRightWords(caption.text)
        }
        //чтобы капча была видна на клонированном слайде при его появлении
        const dataAnimationIn = (this.props.animationIn === 'countdownUp' || this.props.animationIn === 'countdownDown' || this.props.animationIn == 'stripes') ? 'none' : this.props.animationIn
        let HtmlTagToUse = `p`
        if (caption.htmlTag && caption.htmlTag.includes('h')) {
            HtmlTagToUse = caption.htmlTag
        }

        const isCountdown = caption.animationIn.includes('countdown')
        const isCredits = caption.animationIn.includes('credits')
        const stripesColor = getBackgroundGradient({ backgroundColor: caption.stripesColor, stripes: true })
        const stripesSpeedMultiplier = caption.stripesSpeedMultiplier || 1
        

        return (
            <TextCaptionContainer
                style={TextCaptionStyles}
                {...this.state.captionStyle}
                className={`caption-container-${this.props.slideIndex}-${this.props.captionIndex} text-caption-container`}
                onClick={() => this.goToLink()}
                data-animation-in={dataAnimationIn}
                slideJustTranspiled={this.props.slideJustTranspiled}
                textDirection={ParagraphStyles.direction}
                stripesColor={stripesColor}
                stripesSpeedMultiplier={stripesSpeedMultiplier}
                animationIn={caption.animationIn}
                hasAfter={caption.animationIn === 'stripes'}
                isHover={caption.isHover}
            >

                {(isCountdown)
                    ?
                    this.renderCountdownText(caption, ParagraphStyles, this.state.captionStyle, this.getClassname())
                    : (isCredits) ?
                        this.renderCreditsText(caption, ParagraphStyles, this.state.captionStyle, this.getClassname()) :
                        <HtmlTagToUse
                            style={ParagraphStyles}
                            className={this.getClassname()}
                        >
                            <span>
                                {typeof caption.text === 'object' && caption.animationIn === 'typing' ?
                                    caption.text[0]
                                    :
                                    caption.text}
                            </span>

                        </HtmlTagToUse>
                }
            </TextCaptionContainer>
        )
        // return (
        //     <CaptionContainer {...this.state.containerStyle} {...this.state.captionStyle}
        //         isLink={isLink}
        //         onClick={() => this.goToLink()}
        //         className={`caption-container-${this.props.slideIndex}-${this.props.captionIndex} text-caption-container`}
        //         animationIn={this.props.animationIn || 'null'}
        //     >
        //         <p className={this.getClassname()} data-animation-in={this.props.animationIn || 'null'}>
        //             {typeof caption.text === 'object' && caption.animationIn === 'typing' ?
        //                 caption.text[0]
        //                 :
        //                 caption.text}
        //         </p>
        //     </CaptionContainer>
        // )
    }
}

// function mapStateToProps(state) {
//     return state;
// }

// export default connect(mapStateToProps)(TextCaption);
export default TextCaption